export const getAutoPlayAdPreviewsStyles = () => ({
  container: {
    '& .auto-play-placement': {
      maxWidth: '410px',
      width: '100%',
    },
    '& .ad-placement-card-preview': {
      width: 'calc(100% - 32px) !important',
      border: '1px solid #C8C8C8',
      borderRadius: '12px',
      margin: '0px',
      color: '#fff',
      backgroundColor: '#fff',
      boxShadow: '0px 32px 64px 0px rgba(0, 0, 0, 0.19), 0px 2px 21.38px 0px rgba(0, 0, 0, 0.15);',
    },
    '& .cropped-image-view': {
      width: '100% !important',
      '& img': {
        width: '100% !important',
      },
    },

    '& .ResponsiveBingText': {
      '& .business-name-with-ads > .multi-line-ellipsis-text-component': {
        minHeight: 48,
      },
    },

    '& .Responsive_MMA_LandscapeImage_191x100': {
      '& .text-container': {
        padding: '8px 16px 16px 16px',
        '& .short-headline': {
          marginBottom: 4,
          paddingBottom: 4,
        },
      },
    },

    '& .ResponsiveTextOutlookMobile': {
      '& .ad-placement-card-preview': {
        paddingBottom: 15,
        height: 'auto',
      },
    },
  },
  'container-s': {
    '& .placement-item-container': {
      width: '300px',
    },
  },
});
